import { Code, Cog } from '@sharefiledev/icons';
import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { AsyncBlockDevelopment } from './BlockDevelopment';
import { AsyncExtensionDevelopment } from './ExtensionDevelopment';
import { AsyncSmokeTests } from './SmokeTests';

export function addBlockDevelopment(piral: PiletApi) {
	piral.sf.registerLeftNavComponent({
		href: '/configurations-pilet-block-development',
		title: () => 'Configurations Pilet Block Dev',
		icon: Cog,
		weight: 50,
	});
	piral.registerPage('/configurations-pilet-block-development', props => (
		<AsyncBlockDevelopment {...props} />
	));

	piral.sf.registerLeftNavComponent({
		href: '/configurations-pilet-ext-development',
		title: () => 'Configurations Pilet Ext Dev',
		icon: Cog,
		weight: 51,
	});
	piral.registerPage('/configurations-pilet-ext-development', props => (
		<AsyncExtensionDevelopment {...props} />
	));

	piral.sf.registerLeftNavComponent({
		href: '/configurations-pilet-smoke-test',
		title: () => 'Configurations Pilet Smoke Test',
		icon: Code,
	});
	piral.registerPage('/configurations-pilet-smoke-test', props => (
		<AsyncSmokeTests {...props} />
	));
}
